import { Button, Grid, makeStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import CommunityChallengeTemplate from "../../components/commynityChallengeTemplate";
import config from "../../config";
import { dispatch } from "../../events";
import { types } from "../../events/loader";
import httpUtils from "../../utils/http.utils";

const useStyles = makeStyles((theme) => ({
    root: {
        overflow: 'overlay',
        height: 'calc(100vh - 64px)'
    }
}));


const CommunityChallengeTemplates = ({ }) => {
    const classes = useStyles();

    const [challenges, setChallenges] = useState([]);
    const [pagination, setPagination] = useState({ offset: 0, limit: 20 });

    useEffect(() => {
        load();
    }, [])

    const load = async () => {
        dispatch(types.SET_LOADER);

        const results = (await httpUtils.get(`${config.BACK_API}/api/communityChallengeTemplate`,
            { ...pagination }
        )).data.results;

        setChallenges([...challenges, ...results]);
        setPagination({ offset: pagination.offset + results.length })

        dispatch(types.UNSET_LOADER);
    }

    return (
        <Grid container spacing={3} className={classes.root} >
            {challenges.map((challenge) =>
                <Grid item xs={12} sm={4}>
                    <CommunityChallengeTemplate challenge={challenge} />
                </Grid>
            )}
            <Grid item xs={12} sm={12}>
                <Button variant="contained" onClick={load}>Load more</Button>
            </Grid>
        </Grid >
    )
}

export default CommunityChallengeTemplates;